<template>
<div class="leads-report">
    <div class="page-title">
        <div class="title">
            <h3>Leads Report</h3>
        </div>
        <div class="filters">
            <el-form
                label-position="top"
            >
                <el-row :gutter="8">
                    <el-col :xs="24" :sm="12" :md="4" >
                        <el-form-item label="Types">
                            <el-select v-model="form.type"  placeholder="Select" size="small" clearable class="lead-filter-control">
                                <el-option
                                    v-for="item in types"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-form-item class="lead-filter-field" label="Month" size="small" v-if="form.type=='Month'">
                            <el-date-picker
                                v-model="form.month"
                                type="month"
                                placeholder="Pick a month"
                                format="MMM/YYYY"
                                value-format="YYYY-MM"


                            />
                        </el-form-item>
                        <el-form-item class="lead-filter-field" label="Month" size="small" v-else-if="form.type=='Months'">
                            <el-date-picker
                                v-model="form.months"
                                type="monthrange"
                                range-separator="To"
                                start-placeholder="Start month"
                                end-placeholder="End month"
                                format="MMM/YYYY"
                                value-format="YYYY-MM"


                            />
                        </el-form-item>
                        <el-form-item class="lead-filter-field" label="Date" size="small" v-else-if="form.type=='Dates'">
                            <div class="lead-date-time-filter">
                                <el-date-picker
                                    v-model="form.dateRange"
                                    class="lead-date-range"
                                    type="daterange"
                                    range-separator="To"
                                    start-placeholder="Start Date"
                                    end-placeholder="End Date"
                                    format="DD/MMM/YYYY"
                                    value-format="YYYY-MM-DD"
                                />
                                <el-time-picker
                                    v-model="form.startTime"
                                    class="lead-optional-time"
                                    placeholder="Start time"
                                    format="HH:mm"
                                    value-format="HH:mm:ss"
                                    clearable
                                />
                                <el-time-picker
                                    v-model="form.endTime"
                                    class="lead-optional-time"
                                    placeholder="End time"
                                    format="HH:mm"
                                    value-format="HH:mm:ss"
                                    clearable
                                />
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-form-item label="Status">
                            <el-select
                                v-model="tableForm.statuses"
                                multiple
                                collapse-tags
                                collapse-tags-tooltip
                                placeholder="Status"
                                size="small"
                                clearable
                                class="lead-filter-control"
                                @change="onDetailStatusChange"
                            >
                                <el-option
                                    v-for="item in statusOptions"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="12" :md="4">
                        <el-form-item class="lead-filter-apply" label=" .">
                            <el-button @click="applyFilters()"  type="primary" size="small"  round >Apply Filters</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>



            </el-form>



        </div>
    </div>

    <lead-report-summary
        :summary="summary"
        :loading="summaryLoading"
        :active-metric="activeMetric"
        @select="onSummaryMetric"
    />

    <el-card class="box-card mb-3 lead-detail-table-card">
        <template #header>
            <div class="lead-detail-table-header">
                <span>Lead Detail Report</span>
                <div class="lead-detail-filters">
                    <el-date-picker
                        v-model="tableForm.dateRange"
                        class="lead-date-range"
                        type="daterange"
                        range-separator="To"
                        start-placeholder="Start Date"
                        end-placeholder="End Date"
                        format="DD/MMM/YYYY"
                        value-format="YYYY-MM-DD"
                        size="small"
                        clearable
                        @change="onDetailDateChange"
                    />
                    <el-time-picker
                        v-model="tableForm.startTime"
                        class="lead-optional-time"
                        placeholder="Start time"
                        format="HH:mm"
                        value-format="HH:mm:ss"
                        size="small"
                        clearable
                        @change="onDetailStartTimeChange"
                    />
                    <el-time-picker
                        v-model="tableForm.endTime"
                        class="lead-optional-time"
                        placeholder="End time"
                        format="HH:mm"
                        value-format="HH:mm:ss"
                        size="small"
                        clearable
                        @change="onDetailEndTimeChange"
                    />
                    <el-select
                        v-model="tableForm.statuses"
                        multiple
                        collapse-tags
                        collapse-tags-tooltip
                        placeholder="Status"
                        size="small"
                        clearable
                        class="lead-detail-status-select"
                        @change="onDetailStatusChange"
                    >
                        <el-option
                            v-for="item in statusOptions"
                            :key="item"
                            :label="item"
                            :value="item"
                        />
                    </el-select>
                    <el-button type="primary" size="small" round @click="applyTableFilters()">Apply</el-button>
                    <el-select
                        v-if="isNarrow"
                        v-model="mobileSort"
                        size="small"
                        class="lead-mobile-sort"
                        @change="onMobileSortChange"
                    >
                        <el-option
                            v-for="item in mobileSortOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </div>
            </div>
        </template>

        <div v-if="isNarrow" class="lead-mobile-list" v-loading="tableLoading">
            <article v-for="row in tableRows" :key="row.id" class="lead-mobile-card">
                <div class="lead-mobile-card-title">
                    <strong>{{ displayValue(row.name) }}</strong>
                    <span class="lead-type-pill">{{ displayValue(row.lead_type) }}</span>
                </div>
                <div class="lead-mobile-grid">
                    <div><span>Date of Lead</span><b :class="{ 'is-empty': !hasValue(row.lead_date) }">{{ displayValue(row.lead_date) }}</b></div>
                    <div><span>Updated Lead Date</span><b :class="{ 'is-empty': !hasValue(row.updated_lead_date) }">{{ displayValue(row.updated_lead_date) }}</b></div>
                    <div><span>UTM Source</span><b :class="{ 'is-empty': !hasValue(row.utm_source) }">{{ displayValue(row.utm_source) }}</b></div>
                    <div class="lead-mobile-score"><span>AI Score</span><b :class="{ 'is-empty': !hasValue(row.ai_score) }">{{ displayValue(row.ai_score) }}</b></div>
                    <div>
                        <span>First Call Time</span>
                        <b :class="{ 'is-empty': !hasValue(row.first_call_time) }">
                            {{ displayValue(row.first_call_time) }}
                            <el-button v-if="row.calls && row.calls.length > 1" link type="primary" size="small" @click="openEyeDialog('Call History', row.calls, 'calls')"><i class="fa-solid fa-eye"></i></el-button>
                        </b>
                    </div>
                    <div>
                        <span>Strength of Relationship</span>
                        <b :class="{ 'is-empty': !hasValue(row.relationship_strength) }">
                            {{ displayValue(row.relationship_strength) }}
                            <el-button v-if="row.relationship_logs && row.relationship_logs.length > 1" link type="primary" size="small" @click="openEyeDialog('Relationship History', row.relationship_logs, 'logs')"><i class="fa-solid fa-eye"></i></el-button>
                        </b>
                    </div>
                    <div><span>First Quote Send Time</span><b :class="{ 'is-empty': !hasValue(row.first_quote_send_time) }">{{ displayValue(row.first_quote_send_time) }}</b></div>
                    <div><span>Quote Sent time</span><b :class="{ 'is-empty': !hasValue(row.quote_sent_time) }">{{ displayValue(row.quote_sent_time) }}</b></div>
                    <div class="lead-mobile-quote">
                        <span>Quote Value</span>
                        <b :class="{ 'is-empty': !hasValue(row.quote_value) }">
                            {{ displayValue(row.quote_value) }}
                            <el-button v-if="row.quotes && row.quotes.length > 1" link type="primary" size="small" @click="openEyeDialog('Quote Values', row.quotes, 'quotes')"><i class="fa-solid fa-eye"></i></el-button>
                        </b>
                    </div>
                    <div>
                        <span>Next Step</span>
                        <b :class="{ 'is-empty': !hasValue(row.next_step) }">
                            {{ displayValue(row.next_step) }}
                            <el-button v-if="row.next_step_logs && row.next_step_logs.length > 1" link type="primary" size="small" @click="openEyeDialog('Next Step History', row.next_step_logs, 'logs')"><i class="fa-solid fa-eye"></i></el-button>
                        </b>
                    </div>
                    <div>
                        <span>Last Human Contacted</span>
                        <b :class="{ 'is-empty': !hasValue(row.last_human_contacted) }">
                            {{ displayValue(row.last_human_contacted) }}
                            <el-button v-if="row.human_contacts && row.human_contacts.length > 1" link type="primary" size="small" @click="openEyeDialog('Human Contact History', row.human_contacts, 'logs')"><i class="fa-solid fa-eye"></i></el-button>
                        </b>
                    </div>
                    <div><span>Machine Contact Date</span><b :class="{ 'is-empty': !hasValue(row.machine_contact_date) }">{{ displayValue(row.machine_contact_date) }}</b></div>
                </div>
            </article>
            <p v-if="!tableLoading && tableRows.length === 0" class="lead-mobile-empty">No leads found for selected filters</p>
        </div>

        <el-table
            v-else
            :data="tableRows"
            v-loading="tableLoading"
            border
            stripe
            size="small"
            style="width: 100%"
            empty-text="No leads found for selected filters"
            :default-sort="{ prop: 'lead_date', order: 'descending' }"
            @sort-change="onTableSortChange"
        >
            <el-table-column prop="name" label="Name" min-width="140" :fixed="isNarrow ? false : 'left'" sortable="custom" />
            <el-table-column prop="lead_type" label="Lead Type" min-width="110" sortable="custom">
                <template #default="{ row }">{{ displayValue(row.lead_type) }}</template>
            </el-table-column>
            <el-table-column prop="lead_date" label="Date of Lead" min-width="150" sortable="custom">
                <template #default="{ row }">{{ displayValue(row.lead_date) }}</template>
            </el-table-column>
            <el-table-column prop="updated_lead_date" label="Updated Lead Date" min-width="160" sortable="custom">
                <template #default="{ row }">{{ displayValue(row.updated_lead_date) }}</template>
            </el-table-column>
            <el-table-column prop="utm_source" label="UTM Source" min-width="120" sortable="custom">
                <template #default="{ row }">{{ displayValue(row.utm_source) }}</template>
            </el-table-column>
            <el-table-column prop="ai_score" label="AI Score" min-width="100" sortable="custom">
                <template #default="{ row }">{{ displayValue(row.ai_score) }}</template>
            </el-table-column>

            <el-table-column prop="first_call_time" label="First Call Time" min-width="160" sortable="custom">
                <template #default="{ row }">
                    <div class="cell-with-eye">
                        <span>{{ displayValue(row.first_call_time) }}</span>
                        <el-button
                            v-if="row.calls && row.calls.length > 1"
                            link
                            type="primary"
                            size="small"
                            @click="openEyeDialog('Call History', row.calls, 'calls')"
                        >
                            <i class="fa-solid fa-eye"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="relationship_strength" label="Strength of Relationship" min-width="150" sortable="custom">
                <template #default="{ row }">
                    <div class="cell-with-eye">
                        <span>{{ displayValue(row.relationship_strength) }}</span>
                        <el-button
                            v-if="row.relationship_logs && row.relationship_logs.length > 1"
                            link
                            type="primary"
                            size="small"
                            @click="openEyeDialog('Relationship History', row.relationship_logs, 'logs')"
                        >
                            <i class="fa-solid fa-eye"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="first_quote_send_time" label="First Quote Send Time" min-width="160" sortable="custom">
                <template #default="{ row }">{{ displayValue(row.first_quote_send_time) }}</template>
            </el-table-column>

            <el-table-column prop="quote_sent_time" label="Quote Sent time" min-width="130" sortable="custom">
                <template #default="{ row }">{{ displayValue(row.quote_sent_time) }}</template>
            </el-table-column>

            <el-table-column prop="quote_value" label="Quote Value" min-width="130" sortable="custom">
                <template #default="{ row }">
                    <div class="cell-with-eye">
                        <span>{{ displayValue(row.quote_value) }}</span>
                        <el-button
                            v-if="row.quotes && row.quotes.length > 1"
                            link
                            type="primary"
                            size="small"
                            @click="openEyeDialog('Quote Values', row.quotes, 'quotes')"
                        >
                            <i class="fa-solid fa-eye"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="next_step" label="Next Step" min-width="180" sortable="custom">
                <template #default="{ row }">
                    <div class="cell-with-eye">
                        <span>{{ displayValue(row.next_step) }}</span>
                        <el-button
                            v-if="row.next_step_logs && row.next_step_logs.length > 1"
                            link
                            type="primary"
                            size="small"
                            @click="openEyeDialog('Next Step History', row.next_step_logs, 'logs')"
                        >
                            <i class="fa-solid fa-eye"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="last_human_contacted" label="Last Human Contacted" min-width="180" sortable="custom">
                <template #default="{ row }">
                    <div class="cell-with-eye">
                        <span>{{ displayValue(row.last_human_contacted) }}</span>
                        <el-button
                            v-if="row.human_contacts && row.human_contacts.length > 1"
                            link
                            type="primary"
                            size="small"
                            @click="openEyeDialog('Human Contact History', row.human_contacts, 'logs')"
                        >
                            <i class="fa-solid fa-eye"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="machine_contact_date" label="Machine Contact Date" min-width="140" sortable="custom">
                <template #default="{ row }">{{ displayValue(row.machine_contact_date) }}</template>
            </el-table-column>
        </el-table>

        <div class="lead-table-pagination">
            <span v-if="isNarrow" class="lead-table-total">{{ tablePagination.total }} leads</span>
            <el-pagination
                background
                :size="isNarrow ? 'small' : 'default'"
                :pager-count="isNarrow ? 5 : 7"
                :layout="isNarrow ? 'prev, pager, next' : 'total, prev, pager, next, sizes'"
                :total="tablePagination.total"
                :current-page="tablePagination.current_page"
                :page-size="tablePagination.per_page"
                :page-sizes="[10, 20, 50, 100]"
                @current-change="onTablePageChange"
                @size-change="onTableSizeChange"
            />
        </div>
    </el-card>

    <div v-if="!loading">
        <div id="chart">
            <el-row :gutter="12">
                <el-col :xs="24" :sm="24" :md="8">
                    <vue-apex-charts type="donut" height="300" :options="totalleadsstatusCO" :series="reports.leadsstatus.total"></vue-apex-charts>

                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                    <vue-apex-charts type="donut" height="300" :options="totalleadssourceCO" :series="reports.leadssource.total"></vue-apex-charts>

                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                    <vue-apex-charts type="donut" height="300" :options="totalleadsdestCO" :series="reports.leadsdest.total"></vue-apex-charts>

                </el-col>

            </el-row>
            <el-row>
                <el-col :span="24">

                    <vue-apex-charts type="line" height="350" :options="leadsstatusCO" :series="reports.leadsstatus.report"></vue-apex-charts>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">

                    <vue-apex-charts type="line" height="350" :options="leadssourceCO" :series="reports.leadssource.report"></vue-apex-charts>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">

                    <vue-apex-charts type="line" height="350" :options="leadsdestCO" :series="reports.leadsdest.report"></vue-apex-charts>
                </el-col>
            </el-row>
        </div>
    </div>
    <div v-else>
        <el-card class="box-card mt-2 booking-list-box" v-for="i in 7" :key="i">
            <el-skeleton :rows="1" animated />
        </el-card>

    </div>

    <el-dialog
        v-model="eyeDialog.visible"
        :title="eyeDialog.title"
        :width="isNarrow ? '94%' : '720px'"
        class="lead-detail-dialog"
    >
        <el-table :data="eyeDialog.rows" border size="small" style="width: 100%">
            <template v-if="eyeDialog.type === 'quotes'">
                <el-table-column prop="label" label="Quote" min-width="90" />
                <el-table-column prop="quote_price" label="Value" min-width="100" />
                <el-table-column prop="price_type" label="Price Type" min-width="100" />
                <el-table-column prop="status" label="Status" min-width="90" />
                <el-table-column prop="created_at" label="Created" min-width="140" />
            </template>
            <template v-else-if="eyeDialog.type === 'calls'">
                <el-table-column prop="title" label="Call" min-width="120" />
                <el-table-column prop="datetime" label="Date/Time" min-width="150" />
                <el-table-column prop="user" label="By" min-width="120" />
            </template>
            <template v-else>
                <el-table-column prop="title" label="Title" min-width="150" />
                <el-table-column prop="message" label="Details" min-width="220" />
                <el-table-column prop="datetime" label="Date/Time" min-width="150" />
                <el-table-column prop="user" label="By" min-width="120" />
            </template>
        </el-table>
    </el-dialog>
</div>
</template>
<style>

</style>
<script>
import  { ElTable,ElTableColumn,ElSpace,ElPagination,ElSelect, ElOption,ElDatePicker,ElTimePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton,ElDialog  } from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'
import VueApexCharts from "vue3-apexcharts";
import LeadReportSummary from "./LeadReportSummary.vue";
export default {
    name: "LeadsReportList",
    components: { LeadReportSummary, VueApexCharts,ElTable,ElTableColumn,ElSpace,ElPagination,ElSelect,ElOption,ElDatePicker,ElTimePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton,ElDialog },
    data() {
        return {
            isNarrow: typeof window !== 'undefined' && window.innerWidth < 768,
            loading: true,
            summary: null,
            summaryLoading: false,
            activeMetric: null,
            tableRequestId: 0,
            summaryRequestId: 0,
            tableLoading: false,
            tableRows: [],
            tablePagination: {
                current_page: 1,
                per_page: 20,
                total: 0,
                last_page: 1,
            },
            eyeDialog: {
                visible: false,
                title: '',
                type: 'logs',
                rows: [],
            },
            form:{
                dateRange:[moment().startOf('month').format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')],
                startTime:'',
                endTime:'',
                month:moment().startOf('month').format('YYYY-MM'),
                months:[moment().startOf('year').format('YYYY-MM'),moment().startOf('month').format('YYYY-MM')],
                type:'Month',
            },
            tableForm:{
                dateRange:[moment().startOf('month').format('YYYY-MM-DD'),moment().endOf('month').format('YYYY-MM-DD')],
                startTime:'',
                endTime:'',
                statuses:['Pending','InProgress','Converted'],
            },
            tableSort:{
                prop:'lead_date',
                order:'descending',
            },
            mobileSort:'lead_date:desc',
            mobileSortOptions:[
                { label: 'Date of Lead (newest)', value: 'lead_date:desc' },
                { label: 'Date of Lead (oldest)', value: 'lead_date:asc' },
                { label: 'Name (A-Z)', value: 'name:asc' },
                { label: 'Name (Z-A)', value: 'name:desc' },
                { label: 'AI Score (high)', value: 'ai_score:desc' },
                { label: 'AI Score (low)', value: 'ai_score:asc' },
                { label: 'UTM Source (A-Z)', value: 'utm_source:asc' },
                { label: 'Updated Lead Date (newest)', value: 'updated_lead_date:desc' },
            ],
            statusOptions:[
                'Pending',
                'InProgress',
                'Converted',
                'Closed',
            ],
            data:{
                user:null,
                services:[]
            },
            types:[
                'Month',
                'Months',
                'Dates',
            ],
            leadsstatusCO: {
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: true
                },
                stroke: {
                    curve: 'straight',
                    width:2
                },
                title: {
                    text: 'Leads Report',
                    align: 'left'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: [],
                    labels: {
                        rotate: -40,
                        hideOverlappingLabels: true,
                        trim: true,
                        maxHeight: 80,
                    },
                },
                yaxis: {
                    title: {
                        text: 'Leads'
                    },
                    min: 0
                },
                markers: {
                    size: 1
                },

            },
            totalleadsstatusCO:{
                title: {
                    text: 'Total Leads Report',
                    align: 'left'
                },
                legend: {
                    position: 'bottom',
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    width: '100%',
                    type: 'pie',
                },
                labels: [''],
                responsive: [{
                    breakpoint: 992,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            leadssourceCO: {
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: true
                },
                stroke: {
                    curve: 'straight',
                    width:2
                },
                title: {
                    text: 'Leads Source Report',
                    align: 'left'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: [],
                    labels: {
                        rotate: -40,
                        hideOverlappingLabels: true,
                        trim: true,
                        maxHeight: 80,
                    },
                },
                yaxis: {
                    title: {
                        text: 'Leads'
                    },
                    min: 0
                },
                markers: {
                    size: 1
                },

            },
            totalleadssourceCO:{
                legend: {
                    position: 'bottom',
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    width: '100%',
                    type: 'donut',
                },
                title: {
                    text: 'Total Leads Source Report',
                    align: 'left'
                },
                plotOptions:{
                    pie:{
                        donut:{
                            labels:{
                                show: true,
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: 'Total',
                                },
                                name: {
                                    show: false
                                },
                                value: {
                                    show: false
                                }
                            },
                        }
                    },
                },

                responsive: [{
                    breakpoint: 992,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            leadsdestCO: {
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: true
                },
                stroke: {
                    curve: 'straight',
                    width:2
                },
                title: {
                    text: 'Leads Destination Report',
                    align: 'left'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: [],
                    labels: {
                        rotate: -40,
                        hideOverlappingLabels: true,
                        trim: true,
                        maxHeight: 80,
                    },
                },
                yaxis: {
                    title: {
                        text: 'Leads'
                    },
                    min: 0
                },
                markers: {
                    size: 1
                },

            },
            totalleadsdestCO:{
                legend: {
                    position: 'bottom',
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    width: '100%',
                    type: 'donut',
                },
                title: {
                    text: 'Total Leads Destination Report',
                    align: 'left'
                },
                plotOptions:{
                    pie:{
                        donut:{
                            labels:{
                                show: true,
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: 'Total',
                                },
                                name: {
                                    show: false
                                },
                                value: {
                                    show: false
                                }
                            },
                        }
                    },
                },

                responsive: [{
                    breakpoint: 992,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            reports:[]

        }
    },
    mounted() {
        this.updateLayoutWidth();
        this._onLeadReportResize = () => this.updateLayoutWidth();
        window.addEventListener('resize', this._onLeadReportResize);
        this.applyFilters();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this._onLeadReportResize);
    },
    methods: {
        updateLayoutWidth() {
            this.isNarrow = window.innerWidth < 768;
        },
        displayValue(value) {
            if (!this.hasValue(value)) {
                return '-';
            }
            return value;
        },
        hasValue(value) {
            return !(value === null || value === undefined || value === '');
        },
        openEyeDialog(title, rows, type) {
            this.eyeDialog.title = title;
            this.eyeDialog.rows = rows || [];
            this.eyeDialog.type = type || 'logs';
            this.eyeDialog.visible = true;
        },
        applyFilters() {
            this.getlist();
            if (this.form.type === 'Dates') {
                const range = Array.isArray(this.form.dateRange) ? this.form.dateRange.slice(0, 2) : null;
                if (range && range[0] && range[1]) {
                    this.tableForm.dateRange = range.map((value) => String(value).slice(0, 10));
                    this.tableForm.startTime = this.form.startTime || '';
                    this.tableForm.endTime = this.form.endTime || '';
                }
            } else {
                const dates = this.datesFromPageFilter();
                if (dates) {
                    this.tableForm.dateRange = dates;
                    this.tableForm.startTime = '';
                    this.tableForm.endTime = '';
                }
            }
            this.applyTableFilters(false);
        },
        datesFromPageFilter() {
            if (this.form.type === 'Month' && this.form.month) {
                const month = moment(this.form.month, 'YYYY-MM');
                if (!month.isValid()) {
                    return null;
                }
                return [
                    month.clone().startOf('month').format('YYYY-MM-DD'),
                    month.clone().endOf('month').format('YYYY-MM-DD'),
                ];
            }
            if (this.form.type === 'Months' && Array.isArray(this.form.months) && this.form.months.length === 2) {
                const start = moment(this.form.months[0], 'YYYY-MM');
                const end = moment(this.form.months[1], 'YYYY-MM');
                if (!start.isValid() || !end.isValid()) {
                    return null;
                }
                return [
                    start.clone().startOf('month').format('YYYY-MM-DD'),
                    end.clone().endOf('month').format('YYYY-MM-DD'),
                ];
            }
            return null;
        },
        optionalClock(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }
            if (value instanceof Date && !isNaN(value.getTime())) {
                return moment(value).format('HH:mm:ss');
            }
            const text = String(value).trim();
            const parsed = moment(text, ['HH:mm:ss', 'HH:mm', 'H:mm:ss', 'H:mm', 'h:mm:ss A', 'h:mm A'], true);
            if (parsed.isValid()) {
                return parsed.format('HH:mm:ss');
            }
            const match = text.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
            if (!match) {
                return null;
            }
            return match[1].padStart(2, '0') + ':' + match[2] + ':' + (match[3] || '00');
        },
        leadDatePayload(range, startTime, endTime) {
            if (!Array.isArray(range) || range.length < 2 || !range[0] || !range[1]) {
                return null;
            }
            let start = moment(String(range[0]).slice(0, 10), 'YYYY-MM-DD', true);
            let end = moment(String(range[1]).slice(0, 10), 'YYYY-MM-DD', true);
            if (!start.isValid() || !end.isValid()) {
                return null;
            }
            let startClock = this.optionalClock(startTime);
            let endClock = this.optionalClock(endTime);
            if (end.isBefore(start, 'day')) {
                const swap = start;
                start = end;
                end = swap;
                const swapClock = startClock;
                startClock = endClock;
                endClock = swapClock;
            }
            return {
                dates: [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')],
                start_time: startClock,
                end_time: endClock,
            };
        },
        onDetailDateChange() {
            this.applyTableFilters(false);
        },
        onDetailStartTimeChange(value) {
            this.tableForm.startTime = value || '';
            this.applyTableFilters(false);
        },
        onDetailEndTimeChange(value) {
            this.tableForm.endTime = value || '';
            this.applyTableFilters(false);
        },
        onDetailStatusChange(value) {
            this.tableForm.statuses = Array.isArray(value) ? value : [];
            this.applyTableFilters(false);
        },
        applyTableFilters(showError) {
            const filter = this.leadDatePayload(this.tableForm.dateRange, this.tableForm.startTime, this.tableForm.endTime);
            if (!filter) {
                if (showError !== false) {
                    toastr.error('Please select a date range for Lead Detail Report.');
                }
                return;
            }
            this.activeMetric = null;
            this.tablePagination.current_page = 1;
            this.getLeadTable();
            this.getLeadSummary();
        },
        onSummaryMetric(metric) {
            const next = this.metricsMatch(this.activeMetric, metric) ? null : metric;
            if (!this.activeMetric && !next) {
                return;
            }
            this.activeMetric = next;
            this.tablePagination.current_page = 1;
            this.getLeadTable();
        },
        metricsMatch(current, next) {
            if (!current && !next) {
                return true;
            }
            if (!current || !next) {
                return false;
            }
            return current.key === next.key
                && (current.value || null) === (next.value || null)
                && (current.scope || null) === (next.scope || null);
        },
        onTablePageChange(page) {
            this.tablePagination.current_page = page;
            this.getLeadTable();
        },
        onTableSizeChange(size) {
            this.tablePagination.per_page = size;
            this.tablePagination.current_page = 1;
            this.getLeadTable();
        },
        onTableSortChange({ prop, order }) {
            const nextProp = prop || 'lead_date';
            const nextOrder = order || 'descending';
            if (this.tableSort.prop === nextProp && this.tableSort.order === nextOrder) {
                return;
            }
            this.tableSort.prop = nextProp;
            this.tableSort.order = nextOrder;
            this.mobileSort = nextProp + ':' + (nextOrder === 'ascending' ? 'asc' : 'desc');
            this.tablePagination.current_page = 1;
            this.getLeadTable();
        },
        onMobileSortChange(value) {
            const parts = String(value || 'lead_date:desc').split(':');
            const prop = parts[0] || 'lead_date';
            const dir = parts[1] === 'asc' ? 'ascending' : 'descending';
            if (this.tableSort.prop === prop && this.tableSort.order === dir) {
                return;
            }
            this.tableSort.prop = prop;
            this.tableSort.order = dir;
            this.tablePagination.current_page = 1;
            this.getLeadTable();
        },
        getLeadTable() {
            let currentObj = this;
            const filter = this.leadDatePayload(this.tableForm.dateRange, this.tableForm.startTime, this.tableForm.endTime);
            if (!filter) {
                toastr.error('Please select a date range for Lead Detail Report.');
                return;
            }
            const requestId = ++this.tableRequestId;
            currentObj.tableLoading = true;
            const payload = {
                type: 'Dates',
                dates: filter.dates,
                start_time: filter.start_time,
                end_time: filter.end_time,
                statuses: this.tableForm.statuses || [],
                page: this.tablePagination.current_page,
                per_page: this.tablePagination.per_page,
                sort_by: this.tableSort.prop,
                sort_dir: this.tableSort.order === 'ascending' ? 'asc' : 'desc',
            };
            if (this.activeMetric) {
                payload.metric = this.activeMetric.key;
                payload.metric_value = this.activeMetric.value;
                payload.metric_scope = this.activeMetric.scope;
            }
            axios.post('/report/leads/table', payload).then(function (response) {
                if (requestId !== currentObj.tableRequestId) {
                    return;
                }
                currentObj.tableRows = response.data.data || [];
                if (response.data.pagination) {
                    currentObj.tablePagination = Object.assign({}, currentObj.tablePagination, response.data.pagination);
                }
                currentObj.tableLoading = false;
            }).catch(function () {
                if (requestId !== currentObj.tableRequestId) {
                    return;
                }
                currentObj.tableLoading = false;
                toastr.error('Unable to load lead detail table.');
            });
        },
        getLeadSummary() {
            let currentObj = this;
            const filter = this.leadDatePayload(this.tableForm.dateRange, this.tableForm.startTime, this.tableForm.endTime);
            if (!filter) {
                return;
            }
            const requestId = ++this.summaryRequestId;
            currentObj.summaryLoading = true;
            axios.post('/report/leads/summary', {
                type: 'Dates',
                dates: filter.dates,
                start_time: filter.start_time,
                end_time: filter.end_time,
                statuses: this.tableForm.statuses || [],
            }).then(function (response) {
                if (requestId !== currentObj.summaryRequestId) {
                    return;
                }
                currentObj.summary = response.data || null;
                currentObj.summaryLoading = false;
            }).catch(function () {
                if (requestId !== currentObj.summaryRequestId) {
                    return;
                }
                currentObj.summaryLoading = false;
                toastr.error('Unable to load lead summary.');
            });
        },
        getlist() {
            this.loading=true;
            let currentObj = this;
            const filter = this.form.type === 'Dates'
                ? this.leadDatePayload(this.form.dateRange, this.form.startTime, this.form.endTime)
                : null;
            const payload = {
                type: this.form.type,
                month: this.form.month,
                months: this.form.months,
                dates: filter ? filter.dates : null,
                start_time: filter ? filter.start_time : null,
                end_time: filter ? filter.end_time : null,
            };
            axios.post('/report/leads', payload).then(function (response) {

                currentObj.reports=response.data.reports;
                currentObj.data=response.data.data;
                currentObj.leadsstatusCO.xaxis=response.data.reports.leadsstatus.xaxis;
                currentObj.totalleadsstatusCO.labels=response.data.reports.leadsstatus.totalxaxis;
                currentObj.leadssourceCO.xaxis=response.data.reports.leadssource.xaxis;
                currentObj.totalleadssourceCO.labels=response.data.reports.leadssource.totalxaxis;
                currentObj.leadsdestCO.xaxis=response.data.reports.leadsdest.xaxis;
                currentObj.totalleadsdestCO.labels=response.data.reports.leadsdest.totalxaxis;



                currentObj.loading=false;

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        openbooking(link){
            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)

        }
    }
}
</script>

<style scoped>
.leads-report {
    max-width: 100%;
    overflow-x: hidden;
}
.leads-report :deep(.el-select),
.leads-report :deep(.el-date-editor.el-input),
.leads-report :deep(.el-date-editor.el-input__wrapper),
.leads-report :deep(.el-range-editor.el-input__wrapper) {
    width: 100% !important;
    max-width: 100%;
    box-sizing: border-box;
}
.lead-detail-table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    font-weight: 600;
}
.lead-detail-filters {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    font-weight: 400;
    min-width: 0;
}
.lead-date-time-filter {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}
.lead-detail-filters :deep(.el-date-editor.lead-date-range),
.lead-date-time-filter :deep(.el-date-editor.lead-date-range) {
    width: 280px !important;
    max-width: 100%;
}
.lead-detail-filters :deep(.el-date-editor.lead-optional-time),
.lead-date-time-filter :deep(.el-date-editor.lead-optional-time) {
    width: 130px !important;
    max-width: 100%;
}
.lead-detail-status-select {
    min-width: 220px;
}
.cell-with-eye {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}
.lead-table-pagination {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px;
}
.lead-table-total {
    font-size: 13px;
    color: #606266;
}
.lead-mobile-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.lead-mobile-card {
    border: 1px solid #e6e8eb;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
}
.lead-mobile-card-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding: 10px 12px;
    background: #343a40;
}
.lead-mobile-card-title strong {
    color: #fff;
    font-size: 16px;
    line-height: 1.3;
}
.lead-type-pill {
    color: #fff;
    background: rgba(255, 255, 255, 0.16);
    border-radius: 999px;
    padding: 2px 8px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}
.lead-mobile-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
}
.lead-mobile-grid > div {
    min-width: 0;
    padding: 8px 12px;
    border-top: 1px solid #f0f2f5;
}
.lead-mobile-grid > div:nth-child(odd) {
    border-right: 1px solid #f0f2f5;
}
.lead-mobile-grid span {
    display: block;
    color: #909399;
    font-size: 11px;
    line-height: 1.2;
    margin-bottom: 2px;
}
.lead-mobile-grid b {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
    color: #1f2933;
    font-weight: 600;
    font-size: 13px;
    line-height: 1.35;
    word-break: break-word;
}
.lead-mobile-grid b.is-empty {
    color: #c0c4cc;
    font-weight: 500;
}
.lead-mobile-quote {
    grid-column: 1 / -1;
    background: #f3faf5;
    border-right: 0 !important;
}
.lead-mobile-quote b:not(.is-empty) {
    color: #1f7a3a;
    font-size: 16px;
}
.lead-mobile-score b:not(.is-empty) {
    color: #9a6700;
}
.lead-mobile-empty {
    text-align: center;
    color: #909399;
    margin: 12px 0;
}
.lead-mobile-sort {
    width: 100%;
}
.lead-detail-table-card {
    margin-bottom: 16px;
    max-width: 100%;
}
.lead-detail-table-card :deep(.el-table) {
    max-width: 100%;
}
#chart {
    max-width: 100%;
    overflow: hidden;
}
#chart :deep(.apexcharts-canvas),
#chart :deep(svg) {
    max-width: 100%;
}
@media (max-width: 767px) {
    .lead-filter-apply :deep(.el-form-item__label) {
        display: none;
    }
    .lead-detail-table-header,
    .lead-detail-filters {
        flex-direction: column;
        align-items: stretch;
    }
    .lead-detail-status-select {
        min-width: 0;
        width: 100%;
    }
    .lead-detail-filters :deep(.el-date-editor.lead-date-range),
    .lead-date-time-filter :deep(.el-date-editor.lead-date-range),
    .lead-detail-filters :deep(.el-date-editor.lead-optional-time),
    .lead-date-time-filter :deep(.el-date-editor.lead-optional-time) {
        width: 100% !important;
    }
    .lead-detail-filters :deep(.el-button) {
        width: 100%;
    }
    .lead-filter-apply :deep(.el-button) {
        width: 100%;
    }
    .lead-table-pagination {
        justify-content: center;
    }
    .lead-detail-table-card :deep(.el-card__body),
    .lead-detail-table-card :deep(.el-card__header) {
        padding: 10px;
    }
    .leads-report :deep(.el-dialog) {
        max-width: calc(100vw - 16px);
        margin-top: 6vh;
    }
    .leads-report :deep(.el-dialog__body) {
        overflow-x: auto;
        padding: 10px;
    }
}
</style>
